import React from 'react';
import { Leaf, Flower2, Ruler, Calendar, Users } from 'lucide-react';

const iconMap = {
    leaf: Leaf,
    flower: Flower2,
    ruler: Ruler,
    calendar: Calendar,
    family: Users,
};

export default function CompactPlantInfo({ plant, theme = 'light', className = "" }) {
    const isDark = theme === 'dark';
    
    return (
        <div className={`grid grid-cols-2 gap-3 ${className}`}>
            <CompactInfoItem icon="family" label="Familie" isDark={isDark}>
                {plant.family || 'N/A'}
            </CompactInfoItem>

            {plant.flowering_period && (
                <CompactInfoItem icon="calendar" label="Blütezeit" isDark={isDark}>
                    {plant.flowering_period}
                </CompactInfoItem>
            )}

            {plant.height && (
                <CompactInfoItem icon="ruler" label="Höhe" isDark={isDark}>
                    {plant.height}
                </CompactInfoItem>
            )}

            {plant.growth_form && (
                <CompactInfoItem icon="leaf" label="Wuchs" isDark={isDark}>
                    {plant.growth_form}
                </CompactInfoItem>
            )}
        </div>
    );
}

function CompactInfoItem({ icon, label, children, isDark }) {
    const Icon = iconMap[icon] || Leaf;

    return (
        <div className={`
            flex items-center gap-3 p-3 rounded-2xl border transition-all
            ${isDark 
                ? 'bg-white/5 border-white/10 hover:bg-white/10' 
                : 'bg-white border-gray-100 hover:shadow-md'}
        `}>
            <div className={`
                flex-shrink-0 w-8 h-8 rounded-xl flex items-center justify-center
                ${isDark ? 'bg-plantlix-500/20' : 'bg-plantlix-50'}
            `}>
                <Icon className={`w-4 h-4 ${isDark ? 'text-plantlix-400' : 'text-plantlix-600'}`} />
            </div>
            <div className="flex-1 min-w-0">
                <div className={`text-[9px] font-black uppercase tracking-widest ${isDark ? 'text-white/40' : 'text-gray-400'}`}>
                    {label}
                </div>
                <div className={`text-[11px] font-bold truncate ${isDark ? 'text-white/90' : 'text-gray-900'}`}>
                    {children}
                </div>
            </div>
        </div>
    );
}
